import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            lowBorder: anyImageOpResult,
            highBorder: anyImageOpResult,
            mask: anyImageOpResult,
            useLaplacianBlending: z._default(z.boolean(), true),

            debugDrawEnabled: z._default(z.boolean(), false),
            testParam1: z.optional(z.number()),
            testParam2: z.optional(z.number()),
        }),
    },
}
